import { IPublisher } from "../../../@types";
import { ADD_PUBLISHERS } from "../../../utils/constants";

export const actionPublishers = (publishers: IPublisher[]) => {
  return {
    type: ADD_PUBLISHERS,
    payload: publishers,
  };
};
